export function fmtDuration(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${sec}s`;
  return `${sec}s`;
}

export function fmtClock(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const h = String(Math.floor(s / 3600)).padStart(2, "0");
  const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
  const sec = String(s % 60).padStart(2, "0");
  return `${h}:${m}:${sec}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

// Persist an idempotency key for a scoped operation until it is confirmed (then clear it),
// so a retried submission reuses the same key and never creates duplicates.
export function persistedIdemKey(scope) {
  const k = `idem:${scope}`;
  let v = localStorage.getItem(k);
  if (!v) {
    v = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
    localStorage.setItem(k, v);
  }
  return v;
}

export function clearIdemKey(scope) {
  localStorage.removeItem(`idem:${scope}`);
}

export const PRIORITIES = ["Critical", "High", "Normal", "Low"];
export const STATUSES = ["New", "Open", "In Progress", "Waiting for Customer", "Waiting for Vendor", "Resolved", "Closed"];
export const LOCATION_TYPES = ["remote", "onsite", "travel", "other"];
export const BILLING_STATUSES = ["unclassified", "included", "billable", "nonbillable"];

export const PRIORITY_COLOR = {
  Critical: "text-red-400 border-red-500/30 bg-red-500/10",
  High: "text-amber-400 border-amber-500/30 bg-amber-500/10",
  Normal: "text-blue-400 border-blue-500/30 bg-blue-500/10",
  Low: "text-zinc-400 border-white/10 bg-white/5",
};
export const STATUS_COLOR = {
  New: "text-sky-400 border-sky-500/30 bg-sky-500/10",
  Open: "text-blue-400 border-blue-500/30 bg-blue-500/10",
  "In Progress": "text-indigo-400 border-indigo-500/30 bg-indigo-500/10",
  "Waiting for Customer": "text-amber-400 border-amber-500/30 bg-amber-500/10",
  "Waiting for Vendor": "text-orange-400 border-orange-500/30 bg-orange-500/10",
  Resolved: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
  Closed: "text-zinc-400 border-white/10 bg-white/5",
};
export const BILLING_COLOR = {
  unclassified: "text-zinc-400 border-white/10 bg-white/5",
  included: "text-sky-400 border-sky-500/30 bg-sky-500/10",
  billable: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
  nonbillable: "text-zinc-400 border-white/10 bg-white/5",
};
